import React from 'react'
import Layout from '../../components/layout'
import PrepaidSidebar from '../../components/prepaid-sidebar'
import Seo from '../../components/seo'

export default function Contacts(): JSX.Element {
  return (
    <Layout>
      <Seo
        title={'お問い合わせ｜トライアルプリペイドカード｜TRIAL -トライアル-'}
        description={
          'トライアルプリペイドカードに関するお問い合わせ先を掲載しております。'
        }
        canonical={'https://www.trial-net.co.jp/prepaid/contacts/'}
      />
      <div className="prepaid-contacts">
        <h1 className="prepaid-contacts-title">トライアルプリペイドカード</h1>
        <div className="prepaid-contacts-container">
          <div className="prepaid-contacts-main">
            <h2 className="prepaid-contacts-sub-title">お問い合わせ</h2>
            <div className="prepaid-contacts-contact-box">
              <p className="prepaid-contacts-contact-box__title">
                トライアルプリペイドカードに関してのお問い合わせはこちら
              </p>
              <p className="prepaid-contacts-contact-box__company-name">
                株式会社
                {/* <br /> */}
                SU-PAY  
              </p>
              <div className="prepaid-contacts-contact-box__tel">
                <p>ナビダイヤル：0570-078-135</p>
                <p>受付時間：24時間</p>
                <p>※通話料は、お客様負担です。</p>
              </div>
            </div>
          </div>
          <PrepaidSidebar />
        </div>
      </div>
    </Layout>
  )
}
